import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type AdvisorEngineInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type AdvisorEngineInboundContactSyncSettings = {
  autoSync: boolean
  filters: AdvisorEngineInboundContactSyncSettingsFilters
}

export type AdvisorEngineInboundSyncSettings = {
  contact: AdvisorEngineInboundContactSyncSettings
}

export type AdvisorEngineSettingsFormValues = {
  inbound: AdvisorEngineInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const AdvisorEngineSettingsDefaultValues: AdvisorEngineSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export type AdvisorEngineContactCreateSettings = {
  officeId?: string
  securityGroupId?: string
}

export type AdvisorEngineContactCreateFormValues = {
  contactCreate: AdvisorEngineContactCreateSettings
}

export const AdvisorEngineContactCreateDefaultValues: AdvisorEngineContactCreateFormValues = {
  contactCreate: {},
}

export type AdvisorEngineOfficeEntity = {
  offices?: Array<{ id: string; name: string }>
}

export type AdvisorEngineSecurityGroupEntity = {
  securityGroups?: Array<{ securityGroupId: string; name: string }>
}
